const LogOutIcon = ({ ...props }) => (
  <svg viewBox='0 0 24 24' {...props}>
    <path
      d='M16 17l5-5-5-5M21 12H9'
      stroke='currentColor'
      strokeWidth='1.6'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8'
      stroke='currentColor'
      strokeWidth='1.4'
      fill='none'
    />
  </svg>
);

export default LogOutIcon;
